/**
 * dcent-x-fingerprint.js — 지문 스캔 그래픽을 **보일 때만** 재생한다.
 *
 * 마크업은 `snippets/dcent-x-fingerprint-scan.liquid`, 주기는 `dcent-x-fingerprint.css` 의
 * keyframes 가 갖는다. 원본(FingerprintScan.tsx)이 setTimeout 3개로 돌리던 주기는 CSS 로
 * 옮겼고, 여기 남은 일은 `data-play` 토글 하나뿐이다.
 *
 * 화면 밖에서 애니메이션이 도는 것을 막는 것이 목적이다. stroke-dashoffset 은 합성 속성이
 * 아니라 브라우저가 알아서 throttle 해 주지 않는다.
 *
 * 안전 규약 (다른 dcent-* 연출 스크립트와 동일)
 *   - 대상이 없으면 조용히 종료 — 이 스니펫이 없는 페이지에서 로드돼도 죽지 않는다.
 *   - 멱등 설치 — 같은 페이지에 두 번 실려도 관찰자가 겹치지 않는다.
 *   - IntersectionObserver 가 없으면 그냥 켠다 — 연출이 안 보이는 것보다 낫다.
 *   - reduced-motion 은 **CSS 가** 처리한다(정지 + 채워진 상태). 여기서 끄면 빈 능선만 남아
 *     무슨 그림인지 읽히지 않는다.
 *
 * 양 샵 byte-identical — assets/dcent-* 는 parity 게이트 분모다.
 */

if (!window.__dcentXFingerprint) {
  window.__dcentXFingerprint = true;

  const init = () => {
    const nodes = document.querySelectorAll("[data-x-fp]");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach((n) => {
        n.dataset.play = "1";
      });
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.dataset.play = entry.isIntersecting ? "1" : "0";
        });
      },
      { threshold: 0.25 },
    );

    nodes.forEach((n) => {
      if (n.dataset.xFpReady === "1") return; // 멱등
      n.dataset.xFpReady = "1";
      io.observe(n);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
}
